export const CButtonVariants = [
    'default',
    'gray-750',
    'primary',
    'primary-150',
    'primary-dark',
    'primary-outline',
    'secondary',
    'success',
    'success-150',
    'transparent',
    'favourite',
    'white',
    'decline',
    'remove',
    'facebook',
    'google',
    'linkedin',
    'instagram',
    'youtube',
    'vimeo',
    'pinterest',
    'telegram',
    'twitter',
    'whatsapp',
    'blue-800',
    'blue-900',
    'link',
    'primary-link',
    'text',
    'pink',
    'slsp',
    'eduvalue',
    'herobutton',
    'outline',
    'reaction',
    'community'
] as const

export const CButtonSizes = {
    Large: 'large',
    Normal: 'normal',
    Small: 'small'
} as const

export type ButtonVariant = (typeof CButtonVariants)[number]
export type ButtonSize = (typeof CButtonSizes)[keyof typeof CButtonSizes]
